const config: any = {
  rowSelection: true,
  fieldControl: false,
  columns: [
    {
      title: '户型代码',
      dataIndex: 'layoutCode',
      width: 120,
    },
    {
      title: '房屋户型',
      dataIndex: 'layout',
      width: 120,
    },
    {
      title: '朝向',
      dataIndex: 'towards',
      width: 120,
    },
    {
      title: '建筑面积',
      dataIndex: 'constructArea',
      render: 'unitRender',
      width: 150,
    },
    {
      title: '使用面积',
      dataIndex: 'innerArea',
      render: 'unitRender',
      width: 150,
    },
    {
      title: '操作',
      dataIndex: 'actionTool',
      width: 130,
      render: 'actionTool',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'layoutCode',
      label: '户型代码',
      addonOpts: [],
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
    {
      label: '删除',
      type: 'primary',
      disabled: "btnDisabled",
      events: ['onClick:onDel'],
    },
  ],
}
export default config